import { Mesh } from "%COMMON/PolygonMesh";
import { VertexPNT } from "./VertexPNT";


/**
 * This interface represents the model
 */
export interface ModelInterface {
}

/**
 * This class represents the actual model of this program. It is composed of a decorated mesh, 
 * which is a regular polygon mesh but decorated with the ability to resize itself so that it is 
 * enclosed in a cube of side 1 centered at the origin. This makes it easier to transform the 
 * object as required.
 */

export class ObjModel implements ModelInterface {
    //the decorated mesh
    private mesh: Mesh.PolygonMesh<VertexPNT>;

    constructor() {
    }

    //given a regular mesh, make it canonical
    public setMesh(mesh: Mesh.PolygonMesh<VertexPNT>): void {
        this.mesh = mesh;
    }

    public getMesh(): Mesh.PolygonMesh<VertexPNT> {
        return this.mesh;
    }

    //get the vertex shader code
    public getVShader(): string {
        return `attribute vec4 vPosition;
    uniform vec4 vColor;
    uniform mat4 proj;
    uniform mat4 modelview;
    varying vec4 outColor;
    
    void main()
    {
        gl_Position = proj * modelview * vPosition;
        outColor = vColor;
    }
    `;
    }

    //get the fragment shader code
    public getFShader(): string {
        return `precision mediump float;
    varying vec4 outColor;

    void main()
    {
        gl_FragColor = outColor;
    }
    `;
    }
}